/**
* author: duxin
* date: 2020/4/7
* describe:头部导航
*/

<template>
    <header :class="`m-header ${scrollTop ? 'scroll-top':''}`">
        <div class="nav-wrap">
            <img class="logo-web" src="../assets/CSC-logo_text-on-the-right-01.png"/>
            <img class="logo-phone" src="../assets/CSC-logo_text-on-the-right-02(1).png"/>
            <div class="menu-web">
                <KMenu :menus="menuList"></KMenu>
            </div>
            <KMenuPhone class="menu-phone" :menus="menuList"></KMenuPhone>
        </div>
    </header>
</template>

<script>
    import KMenu from "./kllk-menu"
    import KMenuPhone from "./kllk-menu-phone"

    export default {
        name: "kllk-header-nav",
        components: {KMenu, KMenuPhone},
        props: {
            scrollTop: {
                type: Boolean, //是否滑到顶部
                delete: true
            }
        },
        data() {
            return {
                menuList: [
                    {title: this.$t("menu.home"), path: "/home"},
                    {
                        title: this.$t("menu.service"), path: "/service", children:
                            [
                                {title: this.$t("menu.clinical"), path: "/service/clinical"},
                                {title: this.$t("menu.pharmaceutical"), path: "/service/pharmaceutical"},
                                {title: this.$t("menu.affairs"), path: "/service/affairs"},
                                {title: this.$t("menu.management"), path: "/service/management"},
                                {title: this.$t("menu.call"), path: "/service/call"},
                                {title: this.$t("menu.auditing"), path: "/service/auditing"},
                                {title: this.$t("menu.patient"), path: "/service/patient"},
                                {title: this.$t("menu.drug"), path: "/service/drug"},
                                // {title: this.$t("menu.diagnosis"), path: "/service/diagnosis"},
                                {title: this.$t("menu.medical"), path: "/service/medical"},
                                {title: this.$t("menu.food"), path: "/service/food"},
                                {title: this.$t("menu.partner"), path: "/service/partner"}
                            ]
                    },
                    {
                        title: this.$t("menu.info"), path: "/info", children: [
                            {title: this.$t("menu.company"), path: "/info/company"},
                            {title: this.$t("menu.industry"), path: "/info/industry"},
                            {title: this.$t("menu.book"), path: "/info/book"}
                        ]
                    },
                    {
                        title: this.$t("menu.about"), path: "/about", children: [
                            {title: this.$t("menu.companyInfo"), path: "/about/company"},
                            {title: this.$t("menu.children"), path: "/about/children"}
                        ]
                    },
                    {title: this.$t("menu.job"), path: "/join"},
                    {title: this.$t("menu.contact"), path: "/contact"},
                    {title: this.$t("menu.lang"), path: "",call:this.onLang}
                ]
            }
        },
        methods: {
            onShowMenu() {

            },
            onLang(){
                let language = sessionStorage.getItem("language");
                if (language==="en") {
                    sessionStorage.setItem("language","zh");
                }else {
                    sessionStorage.setItem("language","en");
                }
                window.location.reload()
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../style/constant.less";

    .m-header {
        position: fixed;
        top: 0;
        z-index: 200;
        width: 100%;
        background-color: white;
        box-shadow: 0 1px 5px rgba(8, 37, 143, 0.2);
        transition: background-color .3s;

        .nav-wrap {
            display: flex;
            margin: 0 4vw;
            align-items: center;
            height: 70px;
            justify-content: space-between;

            img {
                max-height: 78px;
            }
        }
    }

    .scroll-top {
        box-shadow: none;
        background-color: transparent;
    }

    .menu-web {
        height: 100%;
    }

    .menu-phone {
        display: none;
    }

    .logo-phone {
        display: none;
        height: 50px;
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {

        .nav-wrap {
            margin: 0 10px !important;

            img {
                max-height: 60px;
                max-width: 300px;
            }
        }

        .menu-web {
            display: none;
        }

        .logo-web {
            display: none;
        }

        .logo-phone {
            display: block;
        }

        .menu-phone {
            display: block;
            color: #435ba1;
        }
    }

    /*-----element-----*/

    .el-menu.el-menu--horizontal {
        background-color: transparent;
        border-bottom: none;
    }

    .el-menu-item {
        padding: 0 10px;
    }

    /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
        padding: 0 10px;
    }

</style>